module.exports = __webpack_public_path__ + "media/sheep.40387d76.mp3";